import React, {useContext, useEffect, useState} from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Divider,
  Checkbox,
  Steps,
  Form,
  Input,
  Select,
} from "antd";

import { CheckCircleOutlined } from '@ant-design/icons';
import { permissions } from "../../config/permission";
import { useParams, useNavigate } from "react-router-dom";
import { updateUser, createUser, fetchUserByUUID } from "../../services/user.service";
import { reArrangePermissions } from "../../utils/user.util";
import {showSuccessMessage} from "../../utils/notification.util";
import {roles, roleValues} from "../../config/roles";
import {noAccess} from "../../utils/common";
import {GlobalContext} from "../../context/GlobalContext";

const { Step } = Steps;
const { Option, OptGroup } = Select;

export default function SaveUser() {
    const { setBreadCrumb, user } = useContext(GlobalContext);
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({ fullName: '', email: '', role: '', district: '' });
  const [form] = Form.useForm();
  const geoStates = JSON.parse(localStorage.getItem('GEO_STATES')) || [];
  useEffect(() => {
    if (uuid) {
      fetchUserByUUID(uuid)
      .then((response) => {
        const data = {
          fullName: response.data.fullName,
          email: response.data.email,
          district: response.data.district,
          role: response.data.role,
          permissions: reArrangePermissions(response.data.permissions),
        
        }
        form.setFieldsValue(data);
        
      })
      .catch((error) => {
        console.log(error);
      });
    }
      setBreadCrumb([
          {
              title: 'Users',
              link: `/user-management`,
          },
      ])
      if(user?.role !== roleValues.admin ) {
          noAccess();
      }
  }, []);
  const steps = [
    {
      title: 'User Details',
      content: (
        <>
          <Form.Item
            name="fullName"
            label="Full Name"
            rules={[{ required: true, message: 'Please input the full name!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, message: 'Please input the email!' }]}
          >
            <Input />
          </Form.Item>
            <Form.Item
                name="district"
                label="District"
                rules={[
                    {
                        required: true,
                        message: "Please select an option!",
                    },
                ]}
            >
                <Select>
                    { geoStates.length > 0 && geoStates.map((state) => (
                        <OptGroup label={state?.details?.name}>
                            { state?.districts.map((district) => (
                                <Option key={district.district} value={district.district}>{district.district}</Option>
                            ))}
                        </OptGroup>
                    ))}
                </Select>
            </Form.Item>
        </>
      ),
    },
    {
      title: 'Roles',
      content: (
        <>
          <Form.Item
                name="role"
                label="Role"
                rules={[
                  {
                    required: true,
                    message: "Please select an option!",
                  },
                ]}
              >
                <Select>
                    { roles.map((role) => (
                        <Option key={role.value} value={role.value}>{role.label}</Option>
                    ))}
                </Select>
              </Form.Item>
        </>
      ),
    },
    // {
    //   title: 'Permissions',
    //   content: (
    //     <>
    //   {permissions.map((perm) => (
    //     <div key={perm.key}>
    //       <h4>{perm.title}</h4>
    //       <Form.Item
    //         name={['permissions', perm.key]}
    //         rules={[
    //           {
    //             validator: (_, value) => {
    //               if (!value || value.length === 0) {
    //                 return Promise.reject(`Please select at least one permission for ${perm.title}`);
    //               } else {
    //                 return Promise.resolve();
    //               }
    //             },
    //           },
    //         ]}
    //       >
    //         <Checkbox.Group>
    //           {perm.actions.map((action) => (
    //             <Checkbox
    //               key={action}
    //               value={action}
    //               style={{ display: 'block', marginBottom: 8 }}
    //             >
    //               {action.charAt(0).toUpperCase() + action.slice(1)}
    //             </Checkbox>
    //           ))}
    //         </Checkbox.Group>
    //       </Form.Item>
    //     </div>
    //   ))}
    // </>
    //   ),
    // },
    {
      title: 'Review',
      content: (
        <>
          <Divider>User Details</Divider>
          <p><strong>Full Name:</strong> {formData.fullName}</p>
          <p><strong>Email:</strong> {formData.email}</p>
          <p><strong>Location:</strong> {formData.district}</p>
          <p><strong>Role:</strong> {roles.find(x => x.value === formData.role)?.label}</p>
          {/* <Divider>Permissions</Divider>
          {Object.keys(formData.permissions || {}).map((key) => (
            <div key={key}>
              <h4>{permissions.find((perm) => perm.key === key).title}</h4>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {(formData.permissions[key] || []).map((action) => (
                  <li key={action}>
                    <CheckCircleOutlined style={{ marginLeft: 20, marginRight: 8, color: '#2B77FF' }} /> 
                    {action.charAt(0).toUpperCase() + action.slice(1)}
                  </li>
                ))}
              </ul>
            </div>
          ))} */}
        </>
      ),
    },
  ];

  const next = () => {
    form.validateFields().then(values => {
      setFormData(prevData => ({ ...prevData, ...values }));
      setCurrentStep(currentStep + 1);
    }).catch((error) => {
      console.error('Validation failed:', error);
    });;
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  const onFinish = () => {
    if (uuid) {
      updateUser(uuid, formData).then((response) => {
        showSuccessMessage(`Staff ${formData.fullName} updated successfully!`);
        navigate('/user-management');
      }).catch((error) => {
        console.error('Error updating staff:', error);
      });
      
    } else {
      createUser(formData)
      .then((response) => {
        showSuccessMessage('New staff created successfully!');
        navigate('/user-management');
      })
      .catch((error) => {
        console.error('Error creating staff:', error);
      });
    }
  };

  return (
    <div>
      <Row gutter={[24, 0]}>
      <Col xs={24} xl={12}>
      <Steps current={currentStep}>
        {steps.map(item => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      </Col>
      </Row>
      <Row gutter={[24, 0]} style={{marginTop: '20px'}}>
      <Col xs={24} xl={12}>
      <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              style={{padding: '20px'}}
            >
      <Form form={form} 
        layout="vertical" 
        onFinish={onFinish}
        key={JSON.stringify(formData)}
        initialValues={formData}>
        {steps[currentStep].content}
        <div style={{ marginTop: 24 }}>
          {currentStep < steps.length - 1 && (
            <Button type="primary" onClick={next}>
              Next
            </Button>
          )}
          {currentStep === steps.length - 1 && (
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          )}
          {currentStep > 0 && (
            <Button style={{ marginLeft: 8 }} onClick={prev}>
              Previous
            </Button>
          )}
        </div>
      </Form>
      </Card>
      </Col>
      </Row>
    </div>
  );
}
